import {
  AppDeli,
  GpTech,
  Home,
  MissionVision,
  SocialRes,
} from "../components/About";
import { CompanyInfo } from "../components/Generic";
import { Footer, Header } from "../components/Layouts";

function About() {
  return (
    <>
      <div>
        <Header />
        <Home />
        <div className="">
          <MissionVision />
          <AppDeli />
          {/* <GpTech /> */}
          <SocialRes />
        </div>
        <CompanyInfo />
        <Footer />
      </div>
    </>
  );
}

export default About;
